<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <div class="container-fluid">
        <div class="row" v-if="enable_error_list">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="alert alert-danger">
                    <ol>
                        <li v-for="(error, index) in errors" :key="index">{{ error[0] }}</li>
                    </ol>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xl-7 col-md-7 col-xs-12 col-sm-12 mt-1">
                <div class="dropdown mb-4">
                    <button class="btn btn-info dropdown-toggle" type="button" id="dropdownMenuButton"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Adicionar cliente
                    </button>
                    <div class="dropdown-menu animated--fade-in" aria-labelledby="dropdownMenuButton">
                        <router-link to="/client/new/pf" class="dropdown-item"><i class="fa fa-user"></i>
                            Físico</router-link>
                        <router-link to="/client/new/pj" class="dropdown-item"><i class="fa fa-building"></i>
                            Jurídico</router-link>
                    </div>
                </div>
            </div>
            <div class="col-xl-2 col-md-2 col-xs-12 col-sm-12 offset-xl-3 offset-md-3  mt-1 ">
                <div class="wrapper input-group">

                    <button class="btn btn-light ml-2 " @click="advancedSearch()"><i class="fa fa-align-justify"></i>
                        Busca avançada</button>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="alert alert-success" v-if="user.password != ''">A senha temporária de acesso de {{ user.name
                }} é: <strong>{{ user.password }}</strong> <i class="fa fa-copy pointer"
                        @click="copyPassword()"></i>
                </div>
            </div>
        </div>
        <div class="row mt-3" v-show="advanced_search">
            <div class="col-xl-12 col-md-12 col-xs-12 col-sm-12">
                <fieldset>
                    <div class="row">
                        <div class="col-xl-2 col-md-2 col-xs-12 col-sm-12">
                            <label for="">Matrícula</label>
                            <input type="text" id="document" class="form-control" placeholder="Ex: 1"
                                v-model="advanced_search_input.mat">
                        </div>
                        <div class="col-xl-4 col-md-4 col-xs-12 col-sm-12">
                            <label for="">CPF / CNPJ</label>
                            <input type="text" id="document" class="form-control" placeholder="Ex: José Antônio Silva"
                                v-model="advanced_search_input.document"
                                v-mask="['###.###.###-##', '##.###.###/####-##']">
                        </div>
                        <div class="col-xl-3 col-md-3 col-xs-12 col-sm-12">
                            <label for="">Nome / Razão Social</label>
                            <input type="text" id="description" class="form-control"
                                placeholder="Ex: José Antônio Silva" v-model="advanced_search_input.name">
                        </div>
                         <div class="col-xl-3 col-md-3 col-xs-12 col-sm-12">
                            <label for="">E-mail</label>
                            <input type="email" id="email" class="form-control" placeholder="Ex: usuario@dominio.com"
                                v-model="advanced_search_input.email">
                        </div>
                    </div>

                    <div class="row mt-2">
                        <div class="col-xl-4 col-md-4 col-xs-12 col-sm-12">
                            <label for="">Nome Fantasia</label>
                            <input type="text" id="description" class="form-control" placeholder="Ex: Empresa XYZ"
                                v-model="advanced_search_input.name_fantasy">
                        </div>
                        <div class="col-xl-4 col-md-4 col-sm-12">
                            <label for="">Regime Tributário</label>
                            <div class="input-group mb-3">
                                <select class="form-control" v-model="advanced_search_input.tax_regime">
                                    <option value="all">Todos</option>
                                    <option value="Simples Nacional">Simples Nacional</option>
                                    <option value="Lucro Presumido">Lucro Presumido</option>
                                    <option value="Lucro Real">Lucro Real</option>
                                    <option value="Empresário (individual)">Empresário (individual)</option>
                                </select>
                            </div>
                        </div>
                       
                        <div class="col-xl-4 col-md-4 col-xs-12 col-sm-12">
                            <label for="">Status</label>
                            <select class="form-control" v-model="advanced_search_input.status">
                                <option value="all">Todos</option>
                                <option value="Aguardando cadastro domínio">Aguardando cadastro domínio</option>
                                <option value="Aguardando assinatura contrato">Aguardando assinatura contrato</option>
                                <option value="Aguardando parametrização domínio">Aguardando parametrização domínio
                                </option>
                                <option value="Ativo">Ativo</option>
                                <option value="Baixado">Baixado</option>
                                <option value="Inativo">Inativo</option>
                                <option value="Em distrato">Em distrato</option>
                                <option value="Transferido">Transferido</option>
                            </select>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-xl-6 col-md-6 col-xs-12 col-sm-12">
                            <label for="">Clientes inseridos a partir de</label>
                            <input type="date" id="from" class="form-control" v-model="advanced_search_input.from">
                        </div>
                        <div class="col-xl-6 col-md-6 col-xs-12 col-sm-12">
                            <label for="">Clientes inseridos até</label>
                            <input type="date" id="to" class="form-control" v-model="advanced_search_input.to">
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-xl-12 col-md-12 col-xs-12 col-sm-12">
                            <button class="btn btn-info" @click="executeAdvancedSearch()"> <i
                                    class="fas fa-search fa-sm"></i> Pesquisar</button>
                            <button class="btn btn-danger ml-2" @click="cleanAdvancedSearch()"> <i
                                    class="fas fa-times fa-sm"></i> Limpar</button>
                        </div>

                    </div>
                </fieldset>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="card shadow mb-4">
                    <!-- Card Header - Dropdown -->
                    <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                        <h6 class="m-0 font-weight-bold text-primary">Clientes
                            <br><small><span v-if="total_itens > 0">Total registros encontrados: {{
                                formatDecimal(total_itens) }}</span></small>
                        </h6>
                        <div class="dropdown mb-4">
                            <button class="btn btn-warning dropdown-toggle" type="button" id="dropdownMenuButton"
                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                Ações
                            </button>
                            <div class="dropdown-menu animated--fade-in" aria-labelledby="dropdownMenuButton">
                                <button class="dropdown-item" @click="loadData()"><i class="fa fa-undo"></i> Recarregar
                                    dados</button>
                                <button v-if="clients.length > 0" class="dropdown-item" @click="exportClientXlsx()"><i
                                        class="fas fa-file-excel"></i> Exportar .xlsx</button>
                                <button v-if="clients.length > 0" class="dropdown-item" @click="exportClientJson()"><i
                                        class="fa fa-file"></i> Exportar .json</button>
                            </div>
                        </div>

                    </div>
                    <div class="card-body" :class="clients.length <=0? 'card-body-no-spaccing':''">
                        <div class="table-responsive">
                            <table class="table" id="dataTable" width="100%" cellspacing="0">
                                <thead>
                                    <tr>
                                        <th>Nome</th>
                                        <th>Documento</th>
                                        <th>E-mail</th>
                                        <th>Telefone</th>
                                        <th>Status</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(client) in clients" :key="client.id">
                                        <td class="align-middle pointer" @click="openDetails(client)">{{ client.name
                                            }}<br>
                                            <span v-if="client.mat != ''" class="badge badge-warning">Mat: {{ client.mat
                                                }}</span>
                                        </td>
                                        <td class="align-middle pointer" @click="copyDocument(client)">{{
                                            client.document_formatted }} </td>
                                        <td class="align-middle">{{ client.email ? client.email : '-' }} </td>
                                        <td class="align-middle">{{ client.phone_formatted ? client.phone_formatted :
                                            '-' }} </td>
                                        <td class="align-middle"><span class="badge"
                                                :class="badgeStatus(client.status.status)">{{
                                                    client.status.status }}</span></td>
                                        <td class="align-middle">
                                            <button class="btn btn-primary dropdown-toggle" type="button"
                                                id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                                                aria-expanded="false">
                                                Ações
                                            </button>
                                            <div class="dropdown-menu animated--fade-in"
                                                aria-labelledby="dropdownMenuButton">
                                                <router-link v-if="client.type == 'pf'" class="dropdown-item" :to="{
                                                    name: 'client_pf_edit',
                                                    params: { id: client.id, type: client.type }
                                                }">Detalhes</router-link>
                                                <router-link v-if="client.type == 'pj'" class="dropdown-item" :to="{
                                                    name: 'client_pj_edit',
                                                    params: { id: client.id, type: client.type }
                                                }">Detalhes</router-link>
                                                <!-- <router-link v-if="client.type == 'pj'" class="dropdown-item" :to="{
                                                    name: 'client_managing_partner',
                                                    params: { id: client.id, type: client.type }
                                                }">Sócio-Administrador</router-link> -->
                                                <!-- <router-link v-if="client.type == 'pj'" class="dropdown-item" :to="{
                                                    name: 'client_structure_corporate_edit',
                                                    params: { id: client.id, type: client.type }
                                                }">Quadro Societário (QSA)</router-link> -->
                                                <!-- <router-link class="dropdown-item" :to="{
                                                    name: 'client_certificate_edit',
                                                    params: { id: client.id, type: client.type }
                                                }">Certificados</router-link> -->
                                                <!-- <router-link class="dropdown-item" :to="{
                                                    name: 'client_fiscal_edit',
                                                    params: { id: client.id }
                                                }">Fiscal</router-link> -->
                                                <!-- <router-link class="dropdown-item" :to="{
                                                    name: 'client_access_edit',
                                                    params: { id: client.id }
                                                }">Acessos</router-link> -->
                                                <!-- <router-link class="dropdown-item" :to="{
                                                    name: 'client_service_edit',
                                                    params: { id: client.id }
                                                }">Serviços</router-link> -->
                                                <router-link class="dropdown-item" :to="{
                                                    name: 'client_status_edit',
                                                    params: { id: client.id }
                                                }">Status</router-link>
                                                <router-link class="dropdown-item" :to="{
                                                    name: 'client_file_office_edit',
                                                    params: { id: client.id }
                                                }">Arquivos do escritório</router-link>
                                                <!-- <router-link class="dropdown-item" :to="{
                                                    name: 'client_access_system',
                                                    params: { id: client.id }
                                                }">Acessos plataforma</router-link> -->
                                                <router-link class="dropdown-item" :to="{
                                                    name: 'client_file_edit',
                                                    params: { id: client.id }
                                                }">Área do cliente</router-link>
                                                <button class="dropdown-item" @click="createAccess(client.id)"
                                                    v-if="client.access == null">Criar acesso</button>
                                                <button class="dropdown-item"
                                                    @click="deleteClient(client.id)">Desativar</button>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr v-if="clients.length > 0 && page > 1">
                                        <td colspan="7" class="align-middle text-center pt-5"> <button
                                                @click="loadData()" class="btn btn-info btn-sm"
                                                :disabled="!buttonPagination"><i class="fa fa-spinner"></i> Carregar
                                                mais registros</button></td>
                                    </tr>
                                    <tr v-show="clients.length <= 0">
                                        <td colspan="7" class="text-center">Nenhum registro encontrado</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api';
import { handleRequestErrors } from '@/handleErrors';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import { mask } from 'vue-the-mask'

export default {
    directives: { mask },
    components: { Loading },
    data() {
        return {
            isLoading: true,
            fullPage: true,
            advanced_search: false,
            advanced_search_input: { status: 'all',tax_regime:'all' },
            clients: [],
            page: 1,
            last_page: 1,
            total_itens: 0,
            enable_error_list: false,
            errors: [],
            user: { name: '', password: '' }
        }
    },
    computed: {
        buttonPagination: function () {
            return this.page > 1;
        }
    },
    methods: {
        onCancel() { },
        advancedSearch() {
            this.advanced_search = !this.advanced_search
        },
        closeAdvancedSearch() {
            this.advanced_search = false
        },
        executeAdvancedSearch() {
            this.page = 1;
            this.clients = {};
            this.loadData();
        },
        cleanAdvancedSearch() {
            this.page = 1;
            this.clients = {}
            this.advanced_search_input = { status: 'all',tax_regime:'all' },
                this.loadData();
        },
        formatDecimal(number) {
            return new Intl.NumberFormat().format(number)
        },
        badgeStatus(status) {
            if (status == 'Aguardando cadastro domínio') {
                return 'badge-danger';
            } else if (status == 'Aguardando assinatura contrato') {
                return 'badge-warning';
            } else if (status == 'Aguardando parametrização domínio') {
                return 'badge-info';
            } else if (status == 'Ativo') {
                return 'badge-success';
            } else if (status == 'Inativo' || status == 'Inadiplente') {
                return 'badge-danger';
            }
            return 'badge-info';
        },

        openDetails(client) {
            if (client.type == 'pf') {
                this.$router.push({ name: 'client_pf_edit', params: { id: client.id, type: client.type } });
            } else {
                this.$router.push({ name: 'client_pj_edit', params: { id: client.id, type: client.type } });
            }
        },

        loadData() {
            this.isLoading = true;

            api.get('/client', {
                params: {
                    'mat': this.advanced_search_input.mat,
                    'name': this.advanced_search_input.name,
                    'name_fantasy': this.advanced_search_input.name_fantasy,
                    'document': this.advanced_search_input.document,
                    'tax_regime':this.advanced_search_input.tax_regime,
                    'email': this.advanced_search_input.email,
                    'status': this.advanced_search_input.status,
                    'from': this.advanced_search_input.from,
                    'to': this.advanced_search_input.to,
                    'page': this.page
                }
            })
                .then((response) => {
                    this.isLoading = false;
                    this.last_page = response.data.last_page;
                    this.total_itens = response.data.total_itens;
                    if (this.page <= 1) {
                        this.clients = response.data.data;
                    } else {
                        this.clients = this.clients.concat(response.data.data);
                    }

                    if (this.page < response.data.last_page) {
                        this.page++;
                    } else {
                        this.page = 1;
                    }

                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status);
                })
        },

        async exportClientXlsx() {
            this.isLoading = true;

            api.get('/client-export', {
                responseType: 'blob', params: {
                    'mat': this.advanced_search_input.mat,
                    'name': this.advanced_search_input.name,
                    'name_fantasy': this.advanced_search_input.name_fantasy,
                    'document': this.advanced_search_input.document,
                    'tax_regime':this.advanced_search_input.tax_regime,
                    'email': this.advanced_search_input.email,
                    'status': this.advanced_search_input.status,
                    'from': this.advanced_search_input.from,
                    'to': this.advanced_search_input.to,
                    'page': this.page
                }
            })
                .then((response) => {

                    this.isLoading = false;
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'clientes.xlsx'); // Set the desired file name
                    document.body.appendChild(link);
                    link.click();
                    link.remove(); // Clean up the DOM after the download is initiated

                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status);
                })
        },

        async exportClientJson() {
            this.isLoading = true;

            api.get('/client-export', {
                params: {
                    'mat': this.advanced_search_input.mat,
                    'name': this.advanced_search_input.name,
                    'name_fantasy': this.advanced_search_input.name_fantasy,
                    'document': this.advanced_search_input.document,
                    'tax_regime':this.advanced_search_input.tax_regime,
                    'email': this.advanced_search_input.email,
                    'status': this.advanced_search_input.status,
                    'from': this.advanced_search_input.from,
                    'to': this.advanced_search_input.to,
                    'page': this.page,
                    'type_export': 'json'
                },
                headers: {
                    'Accept': 'application/json; charset=UTF-8',
                    'charset': 'utf-8'
                }
            })
                .then((response) => {
                    this.isLoading = false;
                    const url = window.URL.createObjectURL(new Blob([response.data.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'clientes.json'); // Set the desired file name
                    document.body.appendChild(link);
                    link.click();
                    link.remove(); // Clean up the DOM after the download is initiated

                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status);
                })
        },

        deleteClient(id) {
            this.$confirm(
                {
                    message: 'Deseja desativar o cliente? Nota: ele não será mais listado no módulo. Deseja prosseguir?',
                    button: {
                        no: 'Não',
                        yes: 'Sim'
                    },

                    callback: confirm => {
                        if (confirm) {
                            this.isLoading = true;
                            api.delete('/client/' + id)
                                .then(() => {
                                    this.isLoading = false;
                                    this.$notify({
                                        title: "Sucesso",
                                        text: "Cliente excluído com sucesso",
                                        type: 'success'
                                    });
                                    this.page = 1;
                                    this.loadData();
                                }).catch(error => {
                                    this.isLoading = false;
                                    handleRequestErrors(error.status);
                                })
                        }
                    }
                }
            )
        },
        createAccess(id) {
            this.$confirm(
                {
                    message: 'Deseja criar um acesso para o cliente?',
                    button: {
                        no: 'Não',
                        yes: 'Sim'
                    },

                    callback: confirm => {
                        if (confirm) {
                            this.isLoading = true;
                            api.post('/client/' + id + '/createUser')
                                .then((response) => {
                                    this.isLoading = false;
                                    this.$notify({
                                        title: "Sucesso",
                                        text: "Acesso criado com sucesso. Copie a senha temporária fornecida acima e envie para o cliente.",
                                        type: 'success'
                                    });
                                    this.user = {};
                                    this.user.name = response.data.user.name;
                                    this.user.password = response.data.password;
                                    this.page = 1;
                                    this.loadData();
                                }).catch(error => {
                                    this.isLoading = false;
                                    if (error.status == 422) {
                                        let response_errors = error.response.data.errors;
                                        this.errors = response_errors;
                                        this.enable_error_list = true;
                                    }
                                    handleRequestErrors(error.status, error);
                                })
                        }
                    }
                }
            )
        },
        copyPassword() {
            if (this.user.password != '') {
                navigator.clipboard.writeText(this.user.password);
                this.$notify({
                    title: "Informação",
                    text: "Senha copiada!",
                    type: 'success'
                });
            }
        },
        copyDocument(client) {
            window.navigator.clipboard.writeText(client.document);
            this.$notify({
                title: "Sucesso",
                text: "Documento copiado com sucesso!",
                type: 'success'
            });
        }

    },
    mounted() {
        this.loadData();
    }
}
</script>

<style></style>